import { useSEO } from "@/hooks/useSEO";
import { IMAGES } from "@/config/siteConfig";
import { USPS } from "@/config/usps";
import PageHero from "@/components/PageHero";
import SectionHeading from "@/components/SectionHeading";
import { HowItWorks } from "@/components/home/HomeSections";
import { Testimonials, FinalCTA } from "@/components/home/SocialSections";

const WhyUsPage = () => {
  useSEO({
    title: "Why You'll Love Us | 15 Reasons to Travel With Book Kashmir",
    description: "15 reasons travellers choose Book Kashmir — locally designed trips, on-ground support, transparent pricing, one dedicated trip expert and Kashmir beyond the usual itinerary.",
    path: "/why-youll-love-us",
  });

  return (
    <main data-testid="why-us-page">
      <PageHero image={IMAGES.sonamarg} overline="15+ Years of Travel Expertise" title="Why You'll Love Us"
        subtitle="Fifteen honest reasons travellers plan their Kashmir holiday with us — and come home with stories, not just photos." />

      <section className="py-16 sm:py-24" data-testid="usp-deep-dive-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <SectionHeading overline="The Book Kashmir Way" title="Fifteen Reasons. One Better Holiday."
            subtitle="These aren't slogans — they're how we actually plan, price and support every Kashmir trip." />
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
            {USPS.map(({ icon: Icon, title, long }, i) => (
              <article key={title} className="relative overflow-hidden rounded-xl bg-white p-7 ring-1 ring-[#0F2F24]/8 shadow-sm transition-shadow hover:shadow-md" data-testid={`usp-detail-${i + 1}`}>
                <span className="pointer-events-none absolute -right-2 -top-4 select-none font-serif text-7xl font-bold text-[#E3EAE4]" aria-hidden="true">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-[#0F2F24]">
                  <Icon className="h-5 w-5 text-[#D99B26]" />
                </span>
                <h2 className="mt-4 font-serif text-xl font-semibold text-[#0F2F24] leading-snug">{title}</h2>
                <p className="mt-2 text-sm sm:text-base text-slate-600 leading-relaxed">{long}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <HowItWorks />
      <Testimonials />
      <FinalCTA />
    </main>
  );
};

export default WhyUsPage;
